import { UserFacingError } from './errors'

export class RateAlreadyLinkedError extends UserFacingError {
  constructor(linkedConsumableName?: string) {
    super(
      linkedConsumableName
        ? `That ledger rate is already linked to ${linkedConsumableName}.`
        : 'That ledger rate is already linked to another consumable.',
    )
    this.name = 'RateAlreadyLinkedError'
  }
}

export class ConsumableNotFoundError extends UserFacingError {
  constructor() {
    super('Consumable not found.')
    this.name = 'ConsumableNotFoundError'
  }
}
